import {
  createResource,
  postResource,
  deleteResource,
  postFormDataPrettifierResource,
  postFormDataResource, patchResource,
} from '@resource/resource'

import {
  simpleTransformer,
} from '@resource/transformer'

import { prefixAPI } from '@resource/api'

const MODEL = 'ticket-management/'
const TICKET_MODEL = `${MODEL}ticket/{label}/`

const CREATE_BUYER_URL = prefixAPI('{label}/buyer-register/', MODEL)
const CHECK_TICKETS_URL = prefixAPI('{label}/find/', MODEL)
const UPDATE_TICKET_URL = prefixAPI('update/', TICKET_MODEL)
const DOCUMENT_CREATE_URL = prefixAPI('documents/', TICKET_MODEL)
const DOCUMENT_URL = prefixAPI('documents/{id}/', TICKET_MODEL)
const PARTICIPANT_URL = prefixAPI('participant/', TICKET_MODEL)
export const SPECIALIZATION_URL = prefixAPI('specializations/', MODEL)
export const ADD_TO_WALLET_URL = prefixAPI('ticket/add-to-wallet/', MODEL)
export const PARTICIPANT_SERVICES_URL = prefixAPI('participant-services/', MODEL)
export const SOCIAL_LINK_CREATE_URL = prefixAPI('social-link/create/', TICKET_MODEL)
export const SOCIAL_LINK_DESTROY_URL = prefixAPI('social-link/destroy/{id}/', TICKET_MODEL)
export const SOCIAL_LINK_UPDATE_URL = prefixAPI('social-link/update/{id}/', TICKET_MODEL)

export const createBuyer = createResource(
  CREATE_BUYER_URL, postResource
)
export const participantCreate = createResource(
  PARTICIPANT_URL, postResource
)
export const checkTickets = createResource(
  CHECK_TICKETS_URL, postResource
)
export const createDocument = createResource(
  DOCUMENT_CREATE_URL, postFormDataPrettifierResource
)
export const deleteDocument = createResource(
  DOCUMENT_URL, deleteResource, () => {}
)
export const getSpecialization = createResource(
  SPECIALIZATION_URL
)
export const createSocialLink = createResource(
  SOCIAL_LINK_CREATE_URL, postResource
)
export const updateSocialLink = createResource(
  SOCIAL_LINK_UPDATE_URL, patchResource
)
export const updateTicket = createResource(
  UPDATE_TICKET_URL, patchResource
)
export const destroySocialLink = createResource(
  SOCIAL_LINK_DESTROY_URL, deleteResource
)
export const addToAppleWallet = createResource(
  ADD_TO_WALLET_URL, postResource, simpleTransformer
)
export const addToGoogleWallet = createResource(
  ADD_TO_WALLET_URL, postResource
)
